import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import FitSyncLogo from './FitSyncLogo';
import { FiActivity, FiLayers, FiCalendar, FiDatabase, FiSettings, FiMenu, FiX, FiPlay } from 'react-icons/fi';

const navItems = [
  { id: 'dashboard', icon: FiActivity, label: 'Telemetry' },
  { id: 'demo', icon: FiPlay, label: 'Operations Hub' },
  { id: 'builder', icon: FiLayers, label: 'Sequence Constructor' },
  { id: 'calendar', icon: FiCalendar, label: 'Schedule Matrix' },
  { id: 'library', icon: FiDatabase, label: 'Data Bank' },
  { id: 'settings', icon: FiSettings, label: 'System Prefs' },
];

export default function Navigation({ activeTab, setActiveTab, mobileMenuOpen, setMobileMenuOpen }) {
  return (
    <>
      {/* Mobile Top Bar */}
      <div className="md:hidden fixed top-0 w-full z-50 glass-panel border-b-carbon-700/50 rounded-none flex items-center justify-between p-4">
        <div className="flex items-center gap-3 text-lime-500 font-mono font-bold text-xl tracking-tighter">
          <FitSyncLogo className="w-6 h-6" />
          <span>FITSYNC<span className="text-white">LAB</span></span>
        </div>
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white p-2">
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      {/* Sidebar Desktop */}
      <nav className={`
        fixed md:static inset-y-0 left-0 z-40 transform ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
        md:translate-x-0 transition-transform duration-300 ease-in-out
        w-64 glass-panel border-r-carbon-600/50 rounded-none border-t-0 border-b-0 border-l-0
        flex flex-col h-screen pt-20 md:pt-6
      `}>
        <div className="hidden md:flex items-center gap-3 px-8 mb-12 text-lime-500 font-mono font-bold text-2xl tracking-tighter group cursor-pointer" onClick={() => setActiveTab('dashboard')}>
          <FitSyncLogo className="w-10 h-10 group-hover:scale-110 transition-transform duration-500" />
          <span>FITSYNC<span className="text-white">LAB</span></span>
        </div>

        <div className="flex-1 px-4 space-y-1.5 overflow-y-auto">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                setMobileMenuOpen(false);
              }}
              className={`
                w-full flex items-center gap-3 px-4 py-3.5 rounded-xl transition-all duration-300 relative group
                ${activeTab === item.id ? 'text-carbon-900 font-bold' : 'text-gray-400 hover:text-white hover:bg-carbon-800/50'}
              `}
            >
              <div className="z-10 flex items-center gap-3">
                <SafeIcon icon={item.icon} className={`text-lg transition-colors ${activeTab === item.id ? 'text-carbon-900' : 'group-hover:text-lime-500'}`} />
                <span className="text-[11px] uppercase font-mono tracking-widest">{item.label}</span>
              </div>
              {activeTab === item.id && (
                <motion.div 
                  layoutId="activeNavIndicator"
                  className="absolute inset-0 bg-lime-500 rounded-xl shadow-[0_0_20px_rgba(204,255,0,0.3)]"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
            </button>
          ))}
        </div>

        <div className="p-6 mt-auto">
          <div className="text-[9px] font-mono text-gray-600 bg-carbon-900/80 border border-carbon-700/50 p-4 rounded-xl space-y-2">
            <div className="flex items-center gap-2 text-lime-500/80 font-bold">
              <div className="w-1.5 h-1.5 rounded-full bg-lime-500 animate-pulse" />
              SYSTEM.STABLE
            </div>
            <div className="flex justify-between border-t border-carbon-800 pt-2"><span>Uplink:</span><span className="text-white">Active</span></div>
            <div className="flex justify-between"><span>Latency:</span><span className="text-white">12ms</span></div>
          </div>
        </div>
      </nav>
    </>
  );
}